<template>
    <!-- begin panel -->
    <panel  :title="nuevo ? 'Registrar Nueva Entrega de Chip':'Editar Entrega de Chip'" panelClass="panel-with-tabs"
        variant="default" ref="header" noButton="false">
        <form v-show="!proceso" action="/" method="POST">
            <fieldset>
                <div class="row">
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>Chip Inicial</label>
                            <input type="text" maxlength="18" data-vv-name="inicial" v-validate="'required|numeric'" v-model="entregaChip.chip_inicial" placeholder="Ingrese el rango inicial"
                                class="form-control">
                                 <error :attribute_name="'inicial'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>Chip Final</label>
                            <input type="text"  maxlength="18"  data-vv-name="final" v-validate="'required|numeric'" v-model="entregaChip.chip_final" placeholder="Ingrese el rango final"
                                class="form-control">
                                 <error :attribute_name="'final'" :errors_form="errors" />
                        </div>
                    </div>
                
                    <div class=" col-xl-4 col-lg-4">
                        <div class="form-group">
                            <label>Vendedor</label>
                            <vueSelect 
                             data-vv-name="vendedor" v-validate="'required'"
                            :multiple="false"
                            :filterable="false"
                            :placeholder="'Buscar vendedor'"
                            :source="URL_BASE()+'personal/read/'"
                            :method="'post'"
                            :label="'vendedor'"
                            @selected="buscar($event)"
                            /> 
                        <error :attribute_name="'vendedor'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>Cantidad</label>
                            <input type="text" readonly v-model="entregaChip.cantidad" placeholder="Cantidad"
                                class="form-control text-center font-weight-bold">
                        </div>
                    </div>
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>Chips repetidos</label>
                            <input type="text" readonly v-model="entregaChip.chip_registrados" placeholder="Chips Repetidos"
                                class="form-control text-center font-weight-bold">
                        </div>
                    </div>
                </div>
                <hr>
                <div  v-if="verificar_rango_chip==1" class="row"> 
                    <div class="offset-xl-3 offset-lg-3 offset-md-3  col-xl-5  col-lg-5 col-md-5 text-center">
                      <div class="alert alert-success">
                         <h4> EXCELENTE, NO SE HA DETECTADO CODIGOS REPETIDOS EN EL RANGO</h4> 
                      </div>
                    </div>
                </div>
                <div  v-if="verificar_rango_chip==2" class="row"> 
                    <div class="offset-xl-3 offset-lg-3 offset-md-3  col-xl-5  col-lg-5 col-md-5 text-center">
                      <div class="alert alert-warning">
                         <h4> <i class="ion ion-md-warning fa-2x fa-fw float-start me-10px text-black-lighter"></i>ADVERTENCIA, SE HA DETECTADO <b>{{entregaChip.chip_registrados}}</b> CODIGOS REPETIDOS EN EL RANGO, REALIZAR LA MODIFICACIÓN</h4> 
                      </div>
                    </div>
                </div>
                <div class="row">
                    <div v-if="verificar_rango_chip==1" class=" offset-xl-10 offset-lg-8  offset-md-8 col-xl-1  col-lg-2  col-md-2 text-center">
                        <button type="button" @click="$emit('cancelar')" class="btn btn-default btn-sm btn-circle  btn-block"> <i
                                class="fa fa-times "></i> CANCELAR </button>
                    </div>

                    <div v-if="verificar_rango_chip==0 || verificar_rango_chip==2" class=" offset-xl-10 offset-lg-8  col-xl-2 col-lg-2 col-md-2  text-center">
                        <button type="button"  @click="verificarChip()"
                            class="btn btn-warning btn-sm btn-circle  btn-block"> <i class="fas fa-sync fa-lg"></i> &nbsp; VERIFICAR RANGO </button>
                    </div>
                    <div v-if="verificar_rango_chip==1" class="  col-xl-1 col-lg-2 col-md-2  text-center">
                        <button v-if="nuevo" type="button" @click="validarFormulario('guardar')"
                            class="btn btn-primary btn-sm  btn-block"> <i class="fa fa-save "></i> GUARDAR </button>
                        <button v-else type="button" @click="validarFormulario('actualizar')"
                            class="btn btn-info btn-sm btn-circle  btn-block"> <i class="fa fa-save "></i> EDITAR </button>
                    </div>

                </div>
                

            </fieldset>
        </form>

        <div class="row" v-show="proceso">
            <div class="col-lg-12 text-center">
                <h4>Espere por favor, se está verificando <i class="fa fa-spinner fa-spin fa-lg"></i> </h4>
            </div>
        </div>

    </panel>
    <!-- end panel -->
</template>

<script>
    import error from '../Error'
    import vueSelect from '../VueSelect'
    import axios from 'axios'
    export default {
        name: 'EntregaChipComponent',
        props: ['registro', 'nuevo'],
        components: {
            error,
            vueSelect
        },
        data() {
            return {
                //0: POR VERIFICAR, 1: SIN REPETIDOS, 2: REPETIDOS
                verificar_rango_chip:0,
                proceso:false,
                data: [],
                iniciar_autocompletado: false,
                entregaChip: {
                    chip_inicial: "",
                    chip_final: "",
                    dni_admin: "",
                    dni_vendedor: "",
                    cantidad: "",
                    chip_registrados:'',
                },
            }
        },
        created() {
            setTimeout(() => {
                this.iniciar_autocompletado = true;
            }, 100);

        },
        mounted() {
            if (!this.nuevo) {
                this.entregaChip = {
                    ...this.registro
                };
            } else {
                this.limpiar();
            }
        },
        methods: {
            verificarChip(){

                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.proceso=true;
                    axios.post(this.URL_BASE()+"entrega_chip_vendedor/verificar_rango/",this.entregaChip).then(respuesta => {
                    //   console.log(respuesta.data.msg)
                        if(respuesta.data.msg=='exito'){
                            // this.exito("Comisión registrada correctamente");
                            this.entregaChip.cantidad=respuesta.data.data[0]['cantidad'];
                            this.entregaChip.chip_registrados=respuesta.data.data[0]['chip_registrados'];
                            if(this.entregaChip.chip_registrados>0){
                                this.verificar_rango_chip=2;
                            }else{
                                this.verificar_rango_chip=1;
                            }

                            if(this.entregaChip.cantidad<0){
                                this.verificar_rango_chip=2;
                            }
                        }
                        this.proceso=false;
                    }).catch(function (error) {
                    console.log("er store"+error);
                    });
                }
            });
			},
            validarFormulario(tipo){

                this.$validator.validateAll().then((result) => {
                     this.entregaChip.dni_admin=this.$store.state.usuario.dni;
                    if (result) {
                        if(tipo=='guardar'){
                           
                            this.$emit('guardar',this.entregaChip);
                        }else{
                            this.$emit('actualizar',this.entregaChip);
                            setTimeout(() => {
                                this.$emit('cancelar');
                            }, 250);
                            
                        }
                        return;
                    }
                });
            },
            opcionSeleccionada(seleccion) {
                this.entregaChip.emisor_id = seleccion.id;
            },
            limpiar() {
                this.entregaChip.entregaChip = "";
                this.entregaChip.emisor_id = "";
                this.entregaChip.emisor = "";
                this.entregaChip.estado = "1";
            },
            buscar(vendedor){
                this.entregaChip.dni_vendedor=vendedor.dni;
            }

        }
    }
</script>